import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { adminLogin } from '../../redux/action/adminAction'
import classnames from 'classnames'



const LoginPage = () => {
    const store = useSelector((store) => store)
    const dispatch = useDispatch( )
    const [registrationNumber, setRegistrationNumber] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const history = useHistory()
    useEffect(() => {
        if (store.admin.isAuthenticated) {
            history.push('/adminHome')
        }
    }, [store.admin.isAuthenticated])
    useEffect(() => {
        if (store.error) {
            setError(store.error)
        }
    }, [store.error])

    const fromHandler = (e) => {
        e.preventDefault()
        setIsLoading(true)
        dispatch(adminLogin({registrationNumber, password}))
       
    }

    useEffect(() => {
        if (store.error ||
            store.admin.isAuthenticated) {
            setIsLoading(false)
        }
        
        else {
            setIsLoading(true)
        }
    }, [store.error, store.admin.isAuthenticated])

    
    return (
        <div className="container-fluid"  style={{ backgroundColor: '#233044' }}>
{/* style={{ backgroundImage: 'url(image/adminBg/popup_cleanup.jpg)' }} */}
                    <div className="d-flex flex-column justify-content-center align-items-center vh-100"   >
                    <div className="alert alert-warning alert-dismissible fade show " role="alert">
                        <p className='text-center'><strong> Welcome to the A.R.J College ERP admin login page!</strong> Access to this system is restricted to authorized personnel only. Any unauthorized access or misuse of information is strictly prohibited. By logging in, you agree to abide by the college's policies and maintain the confidentiality of data. Violators will be subject to legal action!!!!</p>
                        {/* <button type="button" className="btn" ><img src="/image/close.svg" alt="" data-bs-dismiss="alert" aria-label="Close"/></button> */}
                        </div>            
                        <div  style={{backgroundImage: 'url(image/adminBg/popup_cleanup.jpg)',backgroundSize:'cover',backgroundPosition:'center' }} className ='bg-light col-7 d-flex flex-column justify-content-center align-items-start p-3 rounded '>
                            <div className=' loginAdmin shadow p-3 rounded d-flex flex-column  justify-content-center align-items-center'>
                            <img src="logo192.png" width={'100px'} alt="" />
                            <h3 className=" text-center">ADMIN LOGIN</h3>
                            <form noValidate onSubmit={fromHandler}>
                                <div className="form-group">
                                    <label htmlFor="emailId"> Admin ID :</label>
                                    <input  onChange={(e) => setRegistrationNumber(e.target.value)} type="text" value={registrationNumber} className={classnames("form-control form-control-lg",
                                        {'is-invalid' : error.registrationNumber
                                        
                                        })} id="emailId"  />
                                    {error.registrationNumber && (<div className="invalid-feedback">{error.registrationNumber}</div>)}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="passwordId">Password :</label>
                                    <input  onChange={(e) => setPassword(e.target.value)} value={password} className={classnames("form-control form-control-lg", {
                                        "is-invalid": error.password
                                    })} type="password" id="passwordId" />
                                    {error.password && (<div className="invalid-feedback">{error.password}</div>)}
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-md-1">
                                        {
                                            isLoading && <div className="spinner-border text-primary" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                                {!isLoading && <button type="submit" className="btn btn-info btn-block">Login</button>}
                            </form>
                            </div>
                        </div>
                    </div>
            </div>
    )
}

export default LoginPage
